import React from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import ProjPicMosley from "../Components/ProjPicMosley";

const ProjectPageMosley = () => {
    return (
        <>
            <Navbar />
            <ProjPicMosley />
            <Footer />
        </>
    );
};

export default ProjectPageMosley;
